<nz-result>
    <img nz-result-icon src="../../../assets/images/error.svg" alt="Erreur 500"/>
    <div nz-result-title>
        <h2 class="text-24-medium">Erreur 500</h2>
    </div>
    <div nz-result-subtitle class="text-16-regular">
        Désolé, nous avons rencontré une erreur.<br/>
        Aucune action n’est nécessaire de votre côté.<br/>
        Nous travaillons à résoudre ce problème.
    </div>
    <div nz-result-extra>
        <a nz-button nzType="primary" href="https://support.ebp.com/hc/fr" target="_blank">
            Contacter le support
        </a>
    </div>
</nz-result>
